import { EFinancingCompany } from '@if/core/types'
import { useUser } from '@src/contexts/AppContext'
import { createContext, Dispatch, SetStateAction, useContext, useEffect, useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'

const SELECTED_COMPANY_LOCAL_STORAGE = 'selectedCompany'

export function clearSelectedCompany(): void {
  localStorage.removeItem(SELECTED_COMPANY_LOCAL_STORAGE)
}

interface TSelectedCompanyContext {
  selectedCompany: EFinancingCompany | null
  setSelectedCompany: Dispatch<SetStateAction<EFinancingCompany | null>>
}
const SelectedCompanyContext = createContext<TSelectedCompanyContext | null>(null)

const SelectedCompanyProvider = () => {
  const user = useUser()

  let userCompany = localStorage.getItem(SELECTED_COMPANY_LOCAL_STORAGE) as EFinancingCompany | null
  if (userCompany === null) userCompany = user?.companyIds?.[0] ?? null
  const [selectedCompany, setSelectedCompany] = useState<EFinancingCompany | null>(userCompany)

  useEffect(() => {
    if (selectedCompany) localStorage.setItem(SELECTED_COMPANY_LOCAL_STORAGE, selectedCompany)
  }, [selectedCompany])

  const value = useMemo<TSelectedCompanyContext>(
    () => ({
      selectedCompany,
      setSelectedCompany,
    }),
    [selectedCompany],
  )

  return (
    <SelectedCompanyContext.Provider value={value}>
      <Outlet />
    </SelectedCompanyContext.Provider>
  )
}

export const useSelectedCompany = () => {
  const ctx = useContext(SelectedCompanyContext)
  return ctx!.selectedCompany!
}

export const useSetSelectedCompany = () => {
  const ctx = useContext(SelectedCompanyContext)
  return ctx!.setSelectedCompany
}

export default SelectedCompanyProvider
